import { Message } from '@meitu/saas-ui';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { MaterialListItem } from '@/services/material/index.d';
import { useAddImageLayer } from './add-image';
import { useAddMaterial } from './add-material';
import { useAddVectorLayer } from './add-vector';

export const useSelectMaterial = () => {
    const { $t } = useLocaleStore();
    const addVectorLayer = useAddVectorLayer();
    const addImageLayer = useAddImageLayer();
    const addMaterial = useAddMaterial();

    return {
        /**
         * 添加素材到舞台
         *
         * @param item - 素材列表项
         * @param param1 - 参数
         */
        append(item: MaterialListItem, byMousePosition = false) {
            const data = {
                ...item,
                thumbnail: item.material_conf?.backgroundImagePath || item.thumbnail?.split('!')[0],
            };

            if (data.svg?.info && data.svg?.image) {
                addVectorLayer.add({ id: data.id, ...data.svg, byMousePosition });
                return;
            }

            if (data.material_conf?.layer) {
                const { width, height } = editor.stage.getSize();
                addMaterial.add({ id: data.id, data, stageWidth: width, stageHeight: height, byMousePosition });
                return;
            }

            addImageLayer.add({ id: data.id, url: data.thumbnail, byMousePosition });
        },
    };
};
